import addressesActionKeys from './addressesActionKeys';
import addressesService from './addressesService';

export const getSPAddresses = serviceProviderId => ({
  type: addressesActionKeys.GET_SP_ADDRESSES,
  payload: addressesService.getSPAddresses(serviceProviderId),
});

export default { getSPAddresses };



// WEBPACK FOOTER //
// ./src/modules/store/common/addressesActions.js